import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { PolylineEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'

/**
 * 绘制多段线命令，支持在交互过程中追加顶点并分步撤销。
 */
export class DrawPolylineCommand extends Command {
  private entity: PolylineEntity
  private viewManager: CADViewManager
  private onUpdateCanvas: () => void

  constructor(entity: PolylineEntity, viewManager: CADViewManager, onUpdateCanvas: () => void) {
    super()
    this.entity = entity
    this.viewManager = viewManager
    this.onUpdateCanvas = onUpdateCanvas
  }

  /** 将多段线加入视图 */
  execute(): void {
    this.viewManager.addEntity(this.entity)
  }

  /** 撤销：从视图中移除多段线 */
  undo(): void {
    // 从场景或图层中移除
    this.viewManager.deleteEntity(this.entity)
  }

  /** 分步撤销：移除最近一个顶点并刷新画布 */
  undoStep(): void {
    // 多段线的分步撤销: 移除最后一个点(不支持端点撤销)
    if (!this.canUndoStep()) {
      return
    }
    this.entity.vertices.pop()
    this.onUpdateCanvas()
  }

  /**
   * 是否支持分步撤销。
   *
   * @returns 顶点数大于 1 时返回 true
   */
  canUndoStep(): boolean {
    return this.entity.vertices.length > 1
  }

  /**
   * 是否允许提交命令。
   *
   * @returns 顶点数大于 1 时返回 true
   */
  canCommit(): boolean {
    return this.entity.vertices.length > 1
  }

  /**
   * 追加一个顶点到多段线末端。
   *
   * @param point - 顶点坐标及可选凸度，bulge 缺省为 0
   */
  addPoint(point: { x: number; y: number; bulge?: number }) {
    this.entity.vertices.push({
      x: point.x,
      y: point.y,
      bulge: point.bulge || 0,
    })
  }
}
